<template style="background-color: #83cae830;">
	<div class="container p-0">
		<div class="row">
			<beat-loader-component v-if="isLoading" :isLoading="isLoading"></beat-loader-component>
		</div>
		<div class="row px-0">
			<div class="card card-shape home-box mb-3 border border-success">
				<div class="card-body py-2">
					<form @submit.prevent="getSingleLoan">
						<div class="row">
							<div class="col">
								<b-form-group id="filter" name="filter" label-for="filter">
									<multiselect id="filter" name="filter" class="mt-2 field-container"
										aria-describedby="filter" v-model="form_filter.filter" :allow-empty="false"
										:options="filter_options">
									</multiselect>
								</b-form-group>
							</div>
							<div class="col">
								<b-form-group id="filter_value" label-for="filter_value">
									<b-form-input id="filter_value" name="filter_value"
										class="mb-2 mt-2 field-container fields" type="text"
										placeholder="Enter Search Value..." v-model="form_filter.filter_value"
										aria-describedby="filter_value" required></b-form-input>
								</b-form-group>
							</div>
							<div class="col-3 my-auto">
								<b-button type="submit" class="akkurate-green-btn akkurate-auth-size w-100"><i
										class="fas fa-search me-2"></i>Search</b-button>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
		<div class="row px-0">
			<div class="card card-shape home-box p-0">
				<div class="rounded-0 card-header py-0 pe-0 akkurate-skyblue-bg">
					<div class="d-flex align-items-center">
						<div class="me-3">
							<h6 class="m-0 fw-bold text-white">
								ACCOUNT PREVIEW
							</h6>
						</div>
						<div class="me-auto px-2 text-white" v-if="
							loan.status !== 'RUNNING' &&
							loan.status !== 'DISBURSED' &&
							loan.status !== 'CLOSED'
						">
							Current Stage:
							<span class="text-uppercase">{{ loan_stage }}</span>
						</div>
						<div class="px-1 text-white me-auto" v-else>
							Current Status:
							<span class="text-uppercase">{{
								loan.status
							}}</span>
						</div>
						<!--  -->

						<!--  -->
						<div class="text-end mx-2">
							<div v-b-tooltip.hover="{ variant: 'info' }" title="Automatically repays loan from savings account based on schedule." class="form-check form-switch form-check-reverse d-flex align-items-center custom-auto-setoff-label">
								<label  class="form-check-label mx-2 text-white" for="defaultCheck1">
									Auto Set-Off
								</label>
								<input @change="updateSetOff" class="form-check-input my-2" type="checkbox"
									role="switch" v-model="au_form.automatic_set_off" name="automatic_set_off"
									id="switchCheckChecked" checked>
							</div>
							<errors v-if="au_form.errors.automatic_set_off">
								{{ au_form.errors.automatic_set_off[0] }}
							</errors>
						</div>
						<div class="text-end">
							<a @click="$bvModal.show('bv-modal-contract')"
								class="text-white custom-pointer"><font-awesome-icon class="me-2"
									:icon="['fas', 'receipt']" /></a>
						</div>
						<div class="text-end">
							<a @click="$bvModal.show('bv-modal-loan-form')"
								class="text-white custom-pointer"><font-awesome-icon class="me-2"
									:icon="['fas', 'scale-balanced']" /></a>
						</div>

						<div class="text-end" v-if="
							loan.status !== 'RUNNING' &&
							loan.status !== 'DISBURSED' &&
							loan.status !== 'REJECTED' &&
							loan.status !== 'CLOSED'" v-show="getLoanApproval">
							<b-button class="akkurate-danger-btn btn-size" @click="rejectLoan(loan.loan_number)">
								<font-awesome-icon class="me-1" :icon="['fas', 'close']" />
								Reject
							</b-button>
							<b-button v-if="stage_id != '1'" class="akkurate-orange btn-size"
								@click="reverseLoan(loan.loan_number)">
								<font-awesome-icon class="me-1" :icon="['fas', 'backward']" />
								Reverse
							</b-button>
							<b-button class="akkurate-green-btn btn-size" @click="approveLoan(loan.loan_number)">
								<font-awesome-icon class="me-1" :icon="['fas', 'forward']" />
								Approve
							</b-button>
						</div>
						
						<div class="text-end" v-if="
							loan.status !== 'RUNNING' &&
							loan.status !== 'DISBURSED' &&
							loan.status !== 'REJECTED' &&
							loan.status !== 'CLOSED'
						" v-show="getLoanDisbursement">
							<b-button class="akkurate-danger-btn btn-size" @click="rejectLoan(loan.loan_number)">
								<font-awesome-icon class="me-2" :icon="['fas', 'close']" />
								Reject
							</b-button>
							<b-button v-if="stage_id != '1'" class="akkurate-orange btn-size"
								@click="reverseLoan(loan.loan_number)">
								<font-awesome-icon class="me-2" :icon="['fas', 'backward']" />
								Reverse
							</b-button>
							<b-button class="akkurate-green-btn btn-size"
								v-b-modal="disbursement.id + 'disbursement'"><font-awesome-icon class="me-2"
									:icon="['fas', 'hand-holding-dollar']" />
								Disburse</b-button>
							<loan-disbursement :loan_account="loan" :institution="institution" :data="disbursement"
								:disbursement="'disbursement'"></loan-disbursement>
						</div>
					</div>
				</div>
				<div class="card-body">
					<div class="row">
						<div class="col text-center">
							<img :src="passportPicUrl" style="height: 200px" class="img-fluid" alt="user-profile" />
							<p class="akkurate-green fw-bold akkurate-small mb-0" style="color: #006885 !important;">
								Profile Image
							</p>
						</div>
						<div class="col text-center">
							<img v-if="imageLoaded" :src="frontImgUrl" alt="Ghana Card Front" @load="handleImageLoad"
								style="height: 200px" class="img-fluid text-center" />
							<img v-else src="@/assets/img/Ghana-Card-Front.png" alt="Ghana Card Front"
								style="height: 180px" class="img-fluid text-center gallery-image" />

							<p class="akkurate-green fw-bold akkurate-small mb-0" style="color: #006885 !important;">
								ID Card Front
							</p>
						</div>
						<div class="col text-center">
							<img v-if="imageLoaded" :src="backImgUrl" alt="Ghana Card Back" @load="handleImageLoad"
								style="height: 200px" class="img-fluid text-center" />
							<img v-else src="@/assets/img/Ghana-Card-Front.png" alt="Ghana Card Back"
								style="height: 180px" class="img-fluid text-center gallery-image" />

							<p class="akkurate-green fw-bold akkurate-small mb-0" style="color: #006885 !important">
								ID Card Back
							</p>
						</div>


						<div class="row col-4 d-flex pb-2" style="background-color: transparent !important;">
							<p class="fw-bolder p-0 m-0 col-12 text-uppercase" style="color: #006885 !important;">
								{{ getFullName }}
							</p>
							<div class="row col-12 akkurate-small mb-2  mt-auto">
								<p class="fw-bolder p-0 m-0 mt-2 col-3" style="color: #006885;">
									{{ loan?.account?.customer?.gender?.toUpperCase() }}
								</p>
								<p class="fw-bolder p-0 m-0 col-9 mt-auto" style="color: #006885;">
									{{ getBranch }}
								</p>
								<p class="fw-bolder p-0 m-0 col-3" style="color: #006885;">ADDRESS:</p>
								<p class="text-wrap p-0 m-0 col-9" style="color: #006885;">
									{{ loan.account?.customer?.address }}
								</p>

								<p class="fw-bolder p-0 m-0 col-3" style="color: #006885;">TEL:</p>
								<p class="col-9 p-0 m-0" style="color: #006885;">
									{{ loan.account?.customer?.mobile }}
								</p>

								<p class="fw-bolder p-0 m-0 col-3" style="color: #006885;">EMAIL:</p>
								<p class="col-9 p-0 m-0" style="color: #006885;">
									{{ loan.account?.customer?.email }}
								</p>

								<p class="fw-bolder p-0 m-0 col-3" style="color: #006885;">REG DATE:</p>
								<p class="col-9 p-0 m-0" style="color: #006885;">
									{{ new Date(loan.account?.customer?.registered_date).toDateString() }}
								</p>
								<p class="fw-bolder p-0 m-0 col-3" style="color: #006885;">STAFF ID:</p>
								<p class="col-9 p-0 m-0" style="color: #006885;">
									ST{{ loan.account?.customer?.id }}
								</p>
							</div>
						</div>
					</div>
					<div class="row akkurate-skyblue-bg text-white akkurate-small fw-bold">
						<div class="col py-1 text-center">
							Shares:
							{{ displayNumber(loan.shares_account_balances) }}
						</div>
						<div class="col py-1 text-center">
							Saving:
							{{ displayNumber(loan.savings_account_balances) }}
						</div>
						<div class="col py-1 text-center">
							Credit:
							{{
								displayNumber(
									loan.principal_paid + loan.interest_paid
								)
							}}
						</div>
						<div class="col py-1 text-center">
							Current Loan
							{{ displayNumber(loan.principal_amount) }}
						</div>
						<div class="col py-1 text-center">Risk Level</div>
						<div class="col py-1 text-center akkurate-green-bg">
							Credit Balance:
							{{
								displayNumber(
									Number(loan.savings_account_balances) -
									Number(loan.principal_balance)
								)
							}}
						</div>
					</div>
					<!-- Tabs Begins -->
					<div class="row mt-1">
						<b-tabs content-class="mt-2" justified @activate-tab="activeTab">
							<b-tab title="Loan Term" :active="term_active_menu" title-link-class="akkurate-small">
								<Terms :loan="loan" :institution="institution" />
							</b-tab>
							<b-tab title="Repayments" :disabled="data.loan.status === 'PENDING' ||
								data.loan.status === 'UNDER_REVIEW'
								" :active="repayment_active_menu" title-link-class="akkurate-small">
								<Repayment :loan="loan" :coa_subheads="coa_subheads"
									:savings_accounts_options="savings_accounts_options" :institution="institution" />
							</b-tab>
							<b-tab title="Statements" :disabled="data.loan.status === 'PENDING' ||
								data.loan.status === 'UNDER_REVIEW'" :active="statement_active_menu" title-link-class="akkurate-small">
								<Statement :loan="data.loan" :institution="this.institution"
									:statement_form="statement_form" :statement="statement"
									@refreshStatement="refreshStatement" />
							</b-tab>
							<b-tab title="Entries" :disabled="data.loan.status === 'PENDING' ||
								data.loan.status === 'UNDER_REVIEW'
								" :active="entries_active_menu" title-link-class="akkurate-small">
								<Entries :loan="this.loan" :institution="institution" :statement_form="statement_form"
									:statement="statement" @refreshStatement="refreshStatement" />
							</b-tab>
							<b-tab :disabled="checkPemission()" title="Adjustment" :active="adjustment_active_menu"
								title-link-class="akkurate-small">
								<Adjustment :data="data" @loanAdjustmenetSaved="
									loanAdjustmenetSaved
								" />
							</b-tab>
							<b-tab title="Top up" :disabled="data.loan.status === 'PENDING' ||
								data.loan.status === 'UNDER_REVIEW' || data.loan.status === 'CLOSED'
								" :active="topup_active_menu" title-link-class="akkurate-small">
								<Topup :loan_number="loan.loan_number" :active_tab_index="active_tab_index"
									:user_role="user_role" :user_pemissions="user_pemissions" :institution="institution"
									:current_user_id="current_user_id" />
							</b-tab>
							<b-tab title="Refinance" :disabled="data.loan.status === 'PENDING' ||
								data.loan.status === 'UNDER_REVIEW' || data.loan.status === 'CLOSED'
								" :active="refinance_active_menu" title-link-class="akkurate-small">
								<LoanRefinance :loan="loan" @refreshRefinancing="refreshRefinancing"
									:scheme_options="scheme_options" />
							</b-tab>
							<b-tab :disabled="data.loan.status === 'PENDING' ||
								data.loan.status === 'UNDER_REVIEW'
								" title="Write off" :active="writeoff_active_menu" title-link-class="akkurate-small">
								<Writeoff :data="write_of_data" />
							</b-tab>
							<b-tab v-if="status_permission" :disabled="data.loan.status === 'PENDING' ||
								data.loan.status === 'UNDER_REVIEW'
								" title="Status" :active="status_active_menu" title-link-class="akkurate-small">
								<Status :loan_number="form_filter?.filter_value" @reloadLoans="reloadLoans" />
							</b-tab>
							<b-tab title="Collaterals" title-link-class="akkurate-small">
								<div class="container akkurate-small">
									<div class="row">
										<b-table striped hover :busy="isBusy" :items="col_items" :fields="col_fields">
											<template #table-busy>
												<div class="text-center text-danger my-2">
													<b-spinner class="align-middle"></b-spinner>
													<strong>Loading...</strong>
												</div>
											</template>
											<template #cell(action)="data">
												<div class="d-flex">
													<picture-view :data="data.item
														?.collateral_pictures
														"></picture-view>
													<document-view :data="data.item
														?.collateral_documents
														"></document-view>
												</div>
											</template>
										</b-table>
									</div>
								</div>
							</b-tab>
							<b-tab title="Guarantors" title-link-class="akkurate-small">
								<div class="container">
									<div class="row table_text_size">
										<b-table striped hover :busy="isBusy" :items="gua_items" :fields="gua_fields">
											<template #table-busy>
												<div class="text-center text-danger my-2">
													<b-spinner class="align-middle"></b-spinner>
													<strong>Loading...</strong>
												</div>
											</template>
											<template #cell(name)="data">
												<p class="m-0">
													{{
														data.item?.account
															?.customer
															?.first_name
													}}
													{{
														data.item?.account
															?.customer?.middle
													}}
													{{
														data.item?.account
															?.customer
															?.last_name
													}}
												</p>
											</template>
										</b-table>
									</div>
								</div>
							</b-tab>
							<b-tab title="Loan history" title-link-class="akkurate-small">
								<loan-history-tab :loan-ref="resolvedLoanRef" />
							</b-tab>
							<b-tab title="Documents" title-link-class="akkurate-small">
								<loan-documents-tab :loan-ref="resolvedLoanRef" />
							</b-tab>
							<b-tab title="Comments" title-link-class="akkurate-small">
								<loan-comments-tab :loan-ref="resolvedLoanRef" />
							</b-tab>
							<b-tab title="Schedule" title-link-class="akkurate-small">
								<div class="position-relative">
									<div class="container">
										<div
											class="d-flex flex-row ps-1 pe-1 justify-content-between akkurate-extra-small w-100 akkurate-skyblue">
											<p class="p-0 m-0 fw-bold text-nowrap" style="width: fit-content;">Missed
												Payments <span class="ms-2 fw-light">{{ getMissedPayment }}</span></p>
											<p class="p-0 m-0 fw-bold text-nowrap" style="width: fit-content;">Missed
												Value <span class="ms-2 fw-light">{{ displayNumber(getMissedValue)
												}}</span></p>

											<p class="p-0 m-0 fw-bold text-nowrap" style="width: fit-content;">Full
												Payments <span class="ms-2 fw-light">{{ getFullPayment }}</span></p>
											<p class="p-0 m-0 fw-bold text-nowrap" style="width: fit-content;">Full
												Payments Value <span class="ms-2 fw-light">{{
													displayNumber(getFullValue) }}</span></p>

											<p class="p-0 m-0 fw-bold text-nowrap" style="width: fit-content;">Patial
												Payments <span class="ms-2 fw-light">{{ getPatialPayment }}</span></p>
											<p class="p-0 m-0 fw-bold text-nowrap" style="width: fit-content;">Patial
												Value <span class="ms-2 fw-light">{{ displayNumber(getPatialValue)
												}}</span></p>

											<p class="p-0 m-0 fw-bold text-nowrap" style="width: fit-content;">
												Difference <span class="ms-2 fw-light">{{ displayNumber(getDiff)
												}}</span></p>

											<div class="text-end akkurate-small">
												<a title="Print Schedule" @click="printSchedulePDF()"
													class="text-white custom-pointer akkurate-small akkurate-green"><font-awesome-icon
														class="akkurate-green akkurate-small"
														:icon="['fas', 'print']" /></a>
											</div>
										</div>
										<div class="w-100">
											<div class="row trans_details p-1" ref="scheduleContent">
												<b-table striped hover :busy="isBusy" :items="payment_items"
													:fields="payment_fields">
													<template #table-busy>
														<div class="text-center text-danger my-2">
															<b-spinner class="align-middle"></b-spinner>
															<strong>Loading...</strong>
														</div>
													</template>
													<!-- A custom formatted column -->
													<!-- <template #empty="scope">
									<h4 class="text-center small mt-3">{{ scope.emptyText }}</h4>
								 </template> -->
													<template #cell(starting_balance)="data">
														<div>
															{{
																displayNumber(
																	data.item
																		.starting_balance
																)
															}}
														</div>
													</template>
													<template #cell(amount_due)="data">
														<div>
															{{
																displayNumber(
																	data.item.amount_due
																)
															}}
														</div>
													</template>
													<template #cell(principal_amount)="data">
														<div>
															{{
																displayNumber(
																	data.item
																		.principal_amount
																)
															}}
														</div>
													</template>
													<template #cell(interest_amount)="data">
														<div>
															{{ displayNumber(data.item.interest_amount) }}
														</div>
													</template>
													<template #cell(ending_balance)="data">
														<div>
															{{
																displayNumber(
																	data.item
																		.ending_balance
																)
															}}
														</div>
													</template>
													<template #cell(index)="data">
														{{ data.index + 1 }}
													</template>
													<template #cell(status)="data">
														<span v-if="
															data.item.status ==
															'Unpaid'
														" class="badge rounded-pill bg-danger">{{
															data.item.status
														}}</span>
														<span v-else-if="
															data.item.status ==
															'Partially Paid'
														" class="badge rounded-pill bg-warning">
															<span class="border">{{
																data.item.status
															}}</span></span>
														<span v-else-if="
															data.item.status === 'Overdue' ||
															data.item.status === 'OVERDUE'
														" class="badge rounded-pill text-white"
															style="background-color: rgb(0, 104, 133)">{{
															data.item.status
														}}</span>
														<span v-else class="badge rounded-pill bg-success">{{
															data.item.status
														}}</span>
													</template>
												</b-table>
											</div>
										</div>
									</div>
								</div>
							</b-tab>
						</b-tabs>
					</div>
				</div>
				<b-modal size="lg" id="bv-modal-contract" hide-footer>
					<template #modal-title>
						<h6 class="akkurate-green fw-bold mb-0">
							Loan Contract
						</h6>
					</template>
					<div class="d-block text-center">
						<loan-contract :institution="institution" :details="loan"></loan-contract>
					</div>
					<b-button @click="$bvModal.hide('bv-modal-contract')" type="submit"
						class="akkurate-gray-btn btn-size float-right">
						<font-awesome-icon class="me-2" :icon="['fas', 'close']" />Close
					</b-button>
				</b-modal>
				<b-modal size="lg" id="bv-modal-loan-form" hide-footer>
					<template #modal-title>
						<h6 class="akkurate-green fw-bold mb-0">Loan Form</h6>
					</template>
					<div class="d-block text-center">
						<loan-forms :institution="institution" :loan="loan"></loan-forms>
					</div>
					<b-button @click="$bvModal.hide('bv-modal-contract')" type="submit"
						class="akkurate-gray-btn btn-size float-right mt-2 me-2 mb-2">
						<font-awesome-icon class="me-2" :icon="['fas', 'close']" />Close
					</b-button>
				</b-modal>
			</div>
		</div>
	</div>
</template>
<script>
import ApiService from "@/core/services/api.service";
import BeatLoaderComponent from "@/views/components/Loader/BeatLoaderComponent.vue";
import PictureView from "./modal/PictureView.vue";
import DocumentView from "./modal/DocumentView.vue";
import LoanForm from "../application/LoanForm.vue";
import LoanFilter from "../statements/form/LoanFilter.vue";
import Multiselect from "vue-multiselect";
// import html2pdf from "html2pdf.js";
import Adjustment from "./loan-actions/Adjustment.vue";
import Terms from "./loan-actions/Terms.vue";
import Repayment from "./loan-actions/Repayment.vue";
import Statement from "./loan-actions/Statement.vue";
import Entries from "./loan-actions/Entries.vue";
import Topup from "./loan-actions/Topup.vue";
import LoanRefinance from './loan-actions/LoanRefinance.vue'
import Writeoff from "./loan-actions/Writeoff.vue";
import Status from "./loan-actions/Status.vue";
import LoanDisbursement from "../disbursement/LoanDisbursement.vue";
import { hasPermission } from "@/helper";
import LoanForms from "./print/LoanForms.vue";
import LoanContract from "./print/LoanContract.vue";
import LoanCommentsTab from "./LoanCommentsTab.vue";
import LoanDocumentsTab from "./LoanDocumentsTab.vue";
import LoanHistoryTab from "./LoanHistoryTab.vue";
import defaultLogo from '@/assets/img/default_logo.png'
import html2pdf from "html2pdf.js";
export default {
	props: [
		"data",
		"institution",
		"user",
		"coa_subheads",
		"term_active_menu",
		"repayment_active_menu",
		"statement_active_menu",
		"entries_active_menu",
		"adjustment_active_menu",
		"topup_active_menu",
		"refinance_active_menu",
		"writeoff_active_menu",
		"user_pemissions",
		"status_active_menu",
		"current_user_id",
		"user_role",
	],
	components: {
		BeatLoaderComponent,
		PictureView,
		DocumentView,
		LoanForm,
		Multiselect,
		LoanFilter,
		Entries,
		Topup,
		Adjustment,
		Terms,
		Repayment,
		Statement,
		LoanRefinance,
		Writeoff,
		Status,
		LoanDisbursement,
		LoanForms,
		LoanContract,
		LoanCommentsTab,
		LoanDocumentsTab,
		LoanHistoryTab,
	},
	data() {
		return {
			// ...this.initialState(),
			active_tab_index: "",
			stage_id: "",
			status_permission: false,
			scheme_options: [],
			loan: {
				status: "",
				tenor: "",
				interest_rate: "",
				interest_method: "",
				expected_interest: "",
				interest_balance: "",
				interest_paid: "",
				interest_balance: "",
				loan_number: "",
				principal_amount: "",
				principal_paid: "",
				principal_balance: "",
				principal_due: "",
				loan_product: "",
				account: "",
				start_date: "",
				last_payment: "",
				delinquent: "",
				interest_due: "",
				interest_rate: "",
				account: {
					customer: {
						passport_pic_path: "",
					},
				},
			},
			form_filter: {
				filter: "Loan Code",
				filter_value: this.data.loan?.loan_number,
			},
			filter_options: ["Loan Code"],
			// term_active_menu: false,
			// statement_active_menu: false,
			// repayment_active_menu: false,
			// other data properties
			write_of_data: {
			},
			savings_accounts_options: [],
			isLoading: false,
			isBusy: false,
			full_name: "",
			search: "Search",
			isSearching: false,
			isSaving: false,
			imageLoaded: false,
			frontImgUrl: "",
			backImgUrl: "",
			passportPicUrl: "",
			products: [],
			canUpdateStatus: false,
			total: "",
			hybrid: false,
			straight_line: false,
			disbursement: {
				id: "loan_disbursement",
			},
			loan_stage: "Awaiting Branch Manager Approval", // Example, this will be dynamic based on the loan stag
			fields: [
				{ key: "payment_terms", label: "Payment Terms" },
				{ key: "after_payments", label: "After Payment" },
			],
			items: [
				{
					payment_terms: { title: "Interest Amount", value: "" },
					after_payments: {
						title: "Interest Outstanding",
						value: "",
					},
				},
				{
					payment_terms: { title: "Principal Amount", value: "" },
					after_payments: {
						title: "Principal Outstanding",
						value: "",
					},
				},
				{
					payment_terms: { title: "Total Repayment", value: "" },
					after_payments: {
						title: "Total Outstanding",
						value: "",
					},
				},
			],
			col_fields: [
				{
					key: "#",
					label: "Index",
				},
				{
					key: "loan_number",
					label: "Loan Number",
				},
				{
					key: "product_name",
					label: "Product Name",
				},
				{
					key: "status",
					label: "Status",
				},
				{
					key: "address",
					label: "Address",
				},
				{
					key: "risk_level",
					label: "Risk Level",
				},
				{
					key: "action",
					label: "Action",
				},
			],
			col_items: [],
			gua_fields: [
				{
					key: "id",
					label: "#",
				},
				{
					key: "loan_number",
					label: "Loan Number",
				},
				{
					key: "amount",
					label: "Amount",
				},
				{
					key: "entry_date",
					label: "Entry Date",
				},
				{
					key: "account.account_number",
					label: "Account Number",
				},
				{
					key: "name",
					label: "Guarantor(s) Name",
				},
			],
			gua_items: [],
			payment_fields: [
				{
					key: "index",
					label: "#",
				},
				{
					key: "due_date",
					label: "Due Date",
				},
				// {
				// 	key: "loan_number",
				// 	label: "Loan Number",
				// },
				{
					key: "starting_balance",
					label: "Starting Balance",
				},
				{
					key: "amount_due",
					label: "Amount Due",
				},
				{
					key: "principal_amount",
					label: "Principal Amount",
				},
				{
					key: "interest_amount",
					label: "Interest Amount",
				},
				{
					key: "ending_balance",
					label: "Ending Balance",
				},
				{
					key: "status",
					label: "Status",
				},
			],
			payment_items: [],
			repayment_columns: [
				{
					label: "Reference",
					field: "code",
				},
				{
					label: "Loan Number",
					field: "account.loan.loan_number",
				},
				{
					label: "Phone number",
					field: "customer.mobile",
				},
				{
					label: "Full name",
					//field: 'customer.first_name',
					field: this.getFullname,
					title: this.getFullname,
				},
				{
					label: "Amount",
					field: "trans_amount",
				},
				{
					label: "Interest",
					field: "interest",
				},
				{
					label: "Principal",
					field: "principal",
				},
				{
					label: "Ext. Ref",
					field: "external_reference",
				},
				{
					label: "Status",
					field: "trans_status",
				},
				{
					label: "Date",
					//field: 'created_at',
					// field: this.getCreatedAt,
					field: "trans_date",
				},
				{
					label: "Source",
					field: "source",
				},
				{
					label: "User",
					field: "user",
				},
				{
					label: "Action",
					field: "action",
					html: true,
					//   formatFn: this.renderActions,
				},
			],
			repayment_items: [],
			statement_form: {
				start_date: this.getOneMonthBeforeDate(),
				end_date: new Date().toISOString().split("T")[0],
			},
			statement: {
				fullname: "",
				customer: "",
				account_number: "",
				gender: "",
				relationship_officer: "",
				created_at: "",
				date_of_birth: "",
				gh_card_front_path: "",
				gh_card_back_path: "",
				interest_balance: "",
				principal_amount: "",
				interest_rate: "",
				account: {},
			},
			au_form: {
				automatic_set_off: false,
				errors: []
			},
			// auto_setoff_options: [
			// 	"Yes",
			// 	"No"
			// ]
		};
	},
	computed: {
		getMissedPayment() {
			let value = 0;
			this.payment_items.forEach((item) => {
				if (item.status == "Unpaid") {
					value++;
				}
			})
			return value;
		},
		getMissedValue() {
			let value = 0;
			this.payment_items.forEach((item) => {
				if (item.status == "Unpaid") {
					value += item.amount_due;
				}
			})
			return value;
		},
		getFullPayment() {
			let value = 0;
			this.payment_items.forEach((item) => {
				if (item.status == "Paid") {
					value++;
				}
			})
			return value;
		},
		getFullValue() {
			let value = 0;
			this.payment_items.forEach((item) => {
				if (item.status == "Paid") {
					value += item.amount_due;
				}
			})
			return value;
		},
		getPatialPayment() {
			let value = 0;
			this.payment_items.forEach((item) => {
				if (item.status == "partially Paid") {
					value++;
				}
			})
			return value;
		},
		getPatialValue() {
			let value = 0;
			this.payment_items.forEach((item) => {
				if (item.status == "partially Paid") {
					value += item.amount_due;
				}
			})
			return value;
		},
		getDiff() {
			return (this.getMissedValue - this.getPatialValue)
		},
		getFullName() {
			const first_name = this.loan.account?.customer?.first_name != undefined ? this.loan.account?.customer?.first_name : "";
			const middle_name = this.loan.account?.customer?.middle_name != undefined ? this.loan.account?.customer?.middle_name : "";
			const last_name = this.loan.account?.customer?.last_name != undefined ? this.loan.account?.customer?.last_name : "";
			return first_name + " " + middle_name + " " + last_name;
		},
		getDuePayment() {
			const payment =
				Number(this.loan?.interest_due ?? 0) +
				Number(this.loan?.principal_due ?? 0);
			return payment.toFixed(2);
		},
		getCurrentValue() {
			const current =
				Number(this.loan?.principal_balance ?? 0) +
				Number(this.loan?.interest_due ?? 0);
			return current.toFixed(2);
		},
		getLoanBalance() {
			const balance =
				Number(this.loan?.interest_balance ?? 0) +
				Number(this.loan?.principal_balance ?? 0);
			return balance.toFixed(2);
		},
		getBranch() {
			const branch = this.loan?.account?.customer?.branch?.name
				? this.loan?.account?.customer?.branch?.name
				: "";
			return branch;
		},


		getLoanApproval() {
			if (
				this.user_role &&
				this.user_pemissions &&
				Array.isArray(this.user_pemissions)
			) {
				const role = this.user_role?.toLowerCase(); // Convert role to lowercase
				const stage = this.loan_stage?.toLowerCase(); // Convert loan stage to lowercase

				if (
					role === "branch manager" &&
					stage === "awaiting branch manager approval"
				) {
					return this.user_pemissions.includes(
						"loan_management_approve"
					);
				} else if (
					role === "general manager" &&
					stage === "awaiting general manager approval"
				) {
					return this.user_pemissions.includes(
						"loan_management_approve"
					);
				} else if (
					role === "head of credit" &&
					stage === "awaiting head of credit approval"
				) {
					return this.user_pemissions.includes(
						"loan_management_approve"
					);
				} else if (
					role === "loan officer" &&
					stage === "awaiting loan officer approval"
				) {
					return this.user_pemissions.includes(
						"loan_management_approve"
					);
				} else if (
					role === "loan committee chairman" &&
					stage === "awaiting loan committee approval"
				) {
					return this.user_pemissions.includes(
						"loan_management_approve"
					);
				} else if (
					role === "operations manager" &&
					stage === "awaiting operations manager approval"
				) {
					return this.user_pemissions.includes(
						"loan_management_approve"
					);
				}
			}
			return false;
		},

		getLoanDisbursement() {
			if (
				this.user_role &&
				this.user_pemissions &&
				Array.isArray(this.user_pemissions)
			) {
				const role = this.user_role?.toLowerCase(); // Convert role to lowercase
				const stage = this.loan_stage?.toLowerCase(); // Convert loan stage to lowercase

				// Check for 'Head of Credit' role and the 'Awaiting Head Of Credit Disbursement' stage
				if (
					role === "head of credit" &&
					stage === "awaiting head of credit disbursement"
				) {
					const approval = this.user_pemissions.filter(
						(index) => index === "loan_management_disburse"
					);
					return approval.length > 0;

					// Check for 'Accountant' role and the 'Awaiting Disbursement' or 'Awaiting Accountant Disbursement' stages
				} else if (
					role === "accountant" &&
					(stage === "awaiting disbursement" ||
						stage === "awaiting accountant disbursement")
				) {
					// console.log(this.loan_stage); // Optional log for debugging
					const approval = this.user_pemissions.filter(
						(index) => index === "loan_management_disburse"
					);
					return approval.length > 0;
				}
			}

			return false; // Default return false if conditions are not met
		},

		getAutomaticSetoff() {
			if (this.loan.automatic_set_off == 0) {
				return false
			}
			return true
		},

		/**
		 * For /loans/{loan}/… (history, comments, attachments):
		 * numeric `loans.id` preferred, else `loan_number` string.
		 */
		resolvedLoanRef() {
			const d = this.data;
			const fromProp =
				d && typeof d === "object"
					? d.id != null
						? d.id
						: d.loan && d.loan.id != null
							? d.loan.id
							: null
					: null;
			const fromLoan =
				this.loan && this.loan.id != null ? this.loan.id : null;
			const raw = fromProp != null ? fromProp : fromLoan;
			const n = Number(raw);
			if (Number.isFinite(n) && n > 0) {
				return n;
			}
			const ln =
				(this.loan && this.loan.loan_number) ||
				(this.data &&
					this.data.loan &&
					this.data.loan.loan_number) ||
				null;
			if (ln != null && String(ln).trim() !== "") {
				return String(ln).trim();
			}
			return null;
		},
	},
	mounted() {
		if (this.data.loan.loan_number != null) {
			this.getSingleLoan();
			this.getLoanStatment();
			this.getScheme();
		}
	},
	methods: {
		activeTab(event) {
			// console.log(event)
			this.active_tab_index = event;
		},
		loanAdjustmenetSaved() {
			this.$emit("loanAdjustmenetSaved");
		},
		checkPemission() {
			this.status_permission = hasPermission(
				"loan_management_status"
			);
			if (
				hasPermission("loan_management_interest_only") ||
				hasPermission("loan_management_interest_principal") ||
				hasPermission("loan_management_adjust_term")
			) {
				return false;
			} else {
				return true;
			}
		},

		reloadLoans() {
			this.$emit("reloadLoans");
		},
		refreshRefinancing() {
			this.reloadLoans();
		},
		getLoanStatment() {
			this.search = "processing...";
			this.isSearching = true;
			ApiService.query("/loans/loanStatements", {
				params: {
					loan_number: this.form_filter?.filter_value,
					start_date: this.statement_form?.start_date,
					end_date: this.statement_form?.end_date,
				},
			}).then((response) => {
				this.statement = response.data.data;
				// this.statement_items = response.data.data.account.transactions;
				// this.search = "Search";
				// this.isSearching = false;
			})
				.catch((error) => {
					this.search = "Search";
					this.isSearching = false;
					// console.log(error)
					if (error.response.status == 404) {
						swal.fire({
							icon: "error",
							title: error.response.statusText,
							text: "Something went wrong!",
							showCancelButton: false, // Show the "Cancel" button
							confirmButtonText: "OK", // Customize the text for the "OK" button
							buttonsStyling: false, // Disable SweetAlert2 styling for buttons
							customClass: {
								confirmButton:
									"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
							},
							// footer: '<a href="#">Why do I have this issue?</a>'
						});
					}
				});
		},
		refreshStatement() {
			this.getLoanStatment()
		},
		handleAmountInput() {
			const interest_due = this.getInterestDue;
			// console.log(last_payment_date);
			// console.log(this.loan.delinquent);
			// console.log(this.loan.principal_balance);
			// const interest_due = this.getInterestDue;
			// console.log(interest_due);

			var interest_amt = this.form.amount;
			var total = this.form.amount;
			var principal_amt = 0;

			if (this.form.amount > interest_due) {
				principal_amt = this.form.amount - interest_due;
				interest_amt = this.form.amount - principal_amt;
				total = principal_amt + interest_due;
			}

			this.items[0].payment_terms.value =
				Math.round(interest_amt * 100) / 100;
			this.items[1].payment_terms.value =
				Math.round(principal_amt * 100) / 100;
			this.items[2].payment_terms.value =
				Math.round(total * 100) / 100;
			// const outstanding = this.loan.principal_balance - this.form.amount;

			var interest_outstanding =
				this.loan.interest_balance -
				Math.round(interest_amt * 100) / 100;

			this.items[0].after_payments.value = interest_outstanding;
			this.items[1].after_payments.value =
				this.loan.interest_balance - interest_outstanding;
			this.items[2].after_payments.value = this.loan.interest_balance;
		},
		async getSingleLoan() {
			this.isLoading = true;
			(this.isBusy = true),
				await ApiService.get(`/loans/${this.form_filter?.filter_value}`).then((response) => {
					this.isLoading = false;
					this.isBusy = false;
					this.loan = response.data.data;
					this.au_form.automatic_set_off = this.getAutomaticSetoff
					this.handleImageLoad()
					// console.log(this.loan.account?.customer.passport_pic_path)
					// console.log(this.loan);

					this.write_of_data = {
						principal_balance: this.loan?.principal_balance,
						loan_type: this.loan.loan_product.name,
						interest_rate: this.loan?.interest_rate,
						interest_method: this.loan?.interest_method,
						interest_rate_frequency: this.loan?.interest_rate_frequency,
						tenure: this.loan.tenor,
						interest_start_date: this.loan?.interest_start_date,
						maturity_date: this.loan?.maturity_date,
						tenure_interval: this.loan?.tenor_interval,
						number_of_payment: this.loan?.number_of_payment,
						expected_interest: this.loan?.expected_interest,
						penalty_rate: this.loan?.penalty_rate,
						reason_for_loan: this.loan?.reason,
						// gl_debit: this.loan?.gl_debit,
						// reason_for_write_of: this.loan?.reason_for_write_of
					}
					this.col_items = response.data.data.collaterals;
					this.gua_items = response.data.data.guarantors;
					this.payment_items = response.data.data.payment_schedules;
					// this.filterLoanStatement();
					this.savings_accounts_options = [
						...response.data.data.savings_accounts,
						...response.data.data.current_accounts
					].flat();
					this.loan_stage = this.loan.loan_approval_level?.name;
					// console.log(this.loan.loan_approval_level?.stage);
					this.stage_id = this.loan.loan_approval_level?.stage;

					// console.log(this.loan);
					// if (response.data?.data?.interest_method == 'straight-line') {
					//    this.straight_line = false;
					//    this.hybrid = true;
					//    // console.log("Straight Line");
					// } else if (response.data?.data?.interest_method == 'reducing-balance') {
					//    this.straight_line = true;
					//    this.hybrid = true;
					// } else if (response.data?.data?.interest_method == 'hybrid') {
					//    this.straight_line = true;
					//    this.hybrid = false;
					// }
					let the_status = response?.data?.data?.status;
					if (
						the_status == "RUNNING" ||
						the_status == "EXPIRED" ||
						the_status == "CLOSED" ||
						the_status == "REJECTED" ||
						the_status == "DISBURSED"
					) {
						this.canUpdateStatus = false;
					} else {
						this.canUpdateStatus = true;
					}
					// this.loadTransactions();

				})
					.catch((error) => {
						this.search = "Search";
						this.isSearching = false;
						// console.log(error);
						if (error.response?.status == 404) {
							swal.fire({
								icon: "error",
								title: error.response.statusText,
								text: "Something went wrong!",
								showCancelButton: false, // Show the "Cancel" button
								confirmButtonText: "OK", // Customize the text for the "OK" button
								buttonsStyling: false, // Disable SweetAlert2 styling for buttons
								customClass: {
									confirmButton:
										"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
								},
								// footer: '<a href="#">Why do I have this issue?</a>'
							});
						}
					});
		},
		handleImageLoad() {
			// console.log("Comments ", this.loan.comments);
			if (this.loan.account.customer.gh_card_front_path != "") {
				this.imageLoaded = true;
				this.frontImgUrl = this.loan.account.customer.gh_card_front_path;
				// this.frontImgUrl = 'https://www.primenewsghana.com/images/2024/may/08/Ghana-Card-1.jpeg';
				// console.log(this.frontImgUrl)
			}
			if (this.loan.account.customer.gh_card_back_path != "") {
				this.imageLoaded = true;
				this.backImgUrl = this.loan.account.customer.gh_card_back_path;
			}

			if (this.loan.account.customer.passport_pic_path != "") {
				this.imageLoaded = true;
				this.passportPicUrl = this.loan.account.customer.passport_pic_path
				// console.log(this.backImgUrl)
			}

		},

		async approveLoan(filter = null) {
			this.isSaving = true;
			this.$Progress.start();
			swal.fire({
				title: "Approve Loan",
				text:
					"Are you sure you want to approve loan number " +
					filter +
					" ?",
				icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				confirmButtonText: "YES",
				cancelButtonText: "NO",
				allowOutsideClick: true,
				customClass: {
					cancelButton:
						"btn btn-size akkurate-danger-btn modal-btn-width text-white me-2", // Custom class for the "NO" button
					confirmButton:
						"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "YES" button
				},
			}).then((result) => {
				if (result.value) {
					this.$Progress.start();
					ApiService.post("/loans/approveLoan", {
						loan_number: filter,
					})
						.then((response) => {
							this.$Progress.finish();
							swal.fire({
								// title: response.statusText,
								text: response.data.message,
								icon: "success",
								allowOutsideClick: true,
								allowEscapeKey: true,
								showCancelButton: false, // Show the "Cancel" button
								confirmButtonText: "okay", // Customize the text for the "OK" button
								buttonsStyling: false, // Disable SweetAlert2 styling for buttons
								customClass: {
									confirmButton:
										"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
								},
							});
							this.getSingleLoan();
							this.$emit("loanApprovedAction");
						})
						.catch((error) => {
							this.$Progress.fail();
							swal.fire({
								// title: response.statusText,
								text: error.response?.data?.message,
								icon: "error",
								allowOutsideClick: true,
								allowEscapeKey: true,
								showCancelButton: false, // Show the "Cancel" button
								confirmButtonText: "okay", // Customize the text for the "OK" button
								buttonsStyling: false, // Disable SweetAlert2 styling for buttons
								customClass: {
									confirmButton:
										"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
								},
							});
						});
				}
			});
		},

		rejectLoan(filter = null) {
			this.isSaving = true;
			this.$Progress.start();
			swal.fire({
				title: "Reject Loan",
				text:
					"Are you sure you want to reject loan number " +
					filter +
					" ?",
				icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				confirmButtonText: "YES",
				cancelButtonText: "NO",
				allowOutsideClick: true,
				customClass: {
					cancelButton:
						"btn btn-size akkurate-green-gray modal-btn-width text-white me-2", // Custom class for the "NO" button
					confirmButton:
						"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "YES" button
				},
			}).then((result) => {
				if (result.value) {
					this.$Progress.start();
					ApiService.post("/loans/rejectLoan", {
						loan_number: filter,
					})
						.then((response) => {
							this.$Progress.finish();
							swal.fire({
								// title: response.statusText,
								text: response.data.message,
								icon: "success",
								allowOutsideClick: true,
								allowEscapeKey: true,
								showCancelButton: false, // Show the "Cancel" button
								confirmButtonText: "okay", // Customize the text for the "OK" button
								buttonsStyling: false, // Disable SweetAlert2 styling for buttons
								customClass: {
									confirmButton:
										"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
								},
							});
							this.getSingleLoan();
							this.$emit("loanApprovedAction");
						})
						.catch((error) => {
							this.$Progress.fail();
							swal.fire({
								// title: response.statusText,
								text: error.response?.data?.message,
								icon: "error",
								allowOutsideClick: true,
								allowEscapeKey: true,
								showCancelButton: false, // Show the "Cancel" button
								confirmButtonText: "okay", // Customize the text for the "OK" button
								buttonsStyling: false, // Disable SweetAlert2 styling for buttons
								customClass: {
									confirmButton:
										"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
								},
							});
						});
				}
			});
		},

		reverseLoan(filter = null) {
			this.isSaving = true;
			this.$Progress.start();
			swal.fire({
				title: "Reverse Loan",
				text:
					"Are you sure you want to reverse loan number " +
					filter +
					" ?",
				icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				confirmButtonText: "YES",
				cancelButtonText: "NO",
				allowOutsideClick: true,
				customClass: {
					cancelButton:
						"btn btn-size akkurate-green-gray modal-btn-width text-white me-2", // Custom class for the "NO" button
					confirmButton:
						"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "YES" button
				},
			}).then((result) => {
				if (result.value) {
					this.$Progress.start();
					ApiService.post("/loans/reverseLoan", {
						loan_number: filter,
					})
						.then((response) => {
							this.$Progress.finish();
							swal.fire({
								// title: response.statusText,
								text: response.data.message,
								icon: "success",
								allowOutsideClick: true,
								allowEscapeKey: true,
								showCancelButton: false, // Show the "Cancel" button
								confirmButtonText: "okay", // Customize the text for the "OK" button
								buttonsStyling: false, // Disable SweetAlert2 styling for buttons
								customClass: {
									confirmButton:
										"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
								},
							});
							this.getSingleLoan();
							this.$emit("loanApprovedAction");
						})
						.catch((error) => {
							this.$Progress.fail();
							swal.fire({
								// title: response.statusText,
								text: error.response?.data?.message,
								icon: "error",
								allowOutsideClick: true,
								allowEscapeKey: true,
								showCancelButton: false, // Show the "Cancel" button
								confirmButtonText: "okay", // Customize the text for the "OK" button
								buttonsStyling: false, // Disable SweetAlert2 styling for buttons
								customClass: {
									confirmButton:
										"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
								},
							});
						});
				}
			});
		},
		clearForm() {
			this.form = this.initialState().form; // Call the initialState method to get the default form
		},
		printSchedulePDF() {
			const originalSchedulContent = this.$refs.scheduleContent; // Reference to the HTML content you want to convert

			const content = document.createElement('div')
			content.classList.add('row')
			content.classList.add('d-flex')
			content.classList.add('flex-column')
			content.style.marginLeft = "8px"
			content.style.marginTop = "10px"
			content.style.marginBottom = "10px"
			content.style.width = "210mm"

			if (!originalSchedulContent)
				return;
			const scheduleContent = originalSchedulContent.cloneNode(true)
			scheduleContent.style.width = "96%"
			scheduleContent.style.marginLeft = "0.6rem"

			const head = document.createElement('div')
			head.classList.add("row");
			head.classList.add("mt-0");
			head.innerHTML = `
				<div
					class="col-md-4 col-4 d-flex align-items-center mb-2 flex-column bd-highlight">
					<!-- First Image -->
					<img
						class="img-fluid img-visibility statement-logo"
						src="${defaultLogo}"
						style="width: 120px !important" />
					<div class="mt-0 akkurate-green fw-bold p-0 bd-highlight">
						LOAN SCHEDULE
					</div>
				</div>
				<div
					class="d-flex align-items-end flex-column bd-highlight col-md-8 col-8 text-end">
					<p class="fw-bold text-uppercase mb-0">
						${this.institution?.name}
					</p>
					<p class="fw-bold mt-0" style="margin-bottom: 0.2rem">
						${this.institution?.motto}
					</p>
					<p class="mb-0 akkurate-small">${this.institution?.postal}</p>
					<p class="mb-0 akkurate-small">
						${this.institution?.telephone}
					</p>
					<p class="akkurate-small mb-0">${this.institution?.email}</p>
					<p
						class="fw-bold text-end mt-auto mb-1 p-0 bd-highlight text-uppercase">
						${new Intl.DateTimeFormat("en-GB", {
				day: "numeric",
				month: "long",
				year: "numeric",
			}).format(Date.now())
				}
					</p>
				</div>

				<hr class="ms-2 mt-0 akkurate-dark mx-auto"  style="width: 98.5%;" />

					<div class="row mb-2">
						<div class="col-md-5">
							<h6 class="akkurate-dark report-l-text">
								MEMBER INFORMATION
							</h6>
							<hr class="w-100 mt-0" />
							<div class="row akkurate-small">
								<div class="col-md-12">
									${this.getFullName}
								</div>
								<div class="col-md-6 fw-bold akkurate-gray">
										${this.loan?.account?.customer?.gender?.toUpperCase()} 
								</div>
								<div class="col-md-6 report-s-text">
											${this.getBranch} 
									
								</div>
								<div class="col-md-6 fw-bold akkurate-gray">
									ADDRESS
								</div>
								<div class="col-md-6 report-s-text">
									${this.loan.account.customer.address}
								</div>
								<div class="col-md-6 fw-bold akkurate-gray">
									TEL:
								</div>
								<div class="col-md-6 report-s-text">
									${this.loan.account.customer.mobile}
								</div>
								<div class="col-md-6 fw-bold akkurate-gray">
									Email
								</div>
								<div class="col-md-6 report-s-text">
									${this.loan.account.customer.email}
								</div>
								<div class="col-md-6 fw-bold akkurate-gray">
									REG. Date
								</div>
								<div class="col-md-6 report-s-text">
									${this.loan.account.customer.registered_date}
								</div>
								<div class="col-md-6 fw-bold akkurate-gray">
									LOAN NUMBER
								</div>
								<div class="col-md-6 report-s-text">
									${this.loan?.loan_number}
								</div>
								<div class="col-md-6 fw-bold akkurate-gray">
									Interest Expected
								</div>
								<div class="col-md-6 report-s-text">
									${this.loan?.expected_interest}
								</div>
							</div>
						</div>
						<div class="col-md-2"></div>
						<div class="col-md-5">
							<h6 class="akkurate-dark report-l-text">
								LOAN INFORMATION
							</h6>
							<hr class="w-100 mt-0" />
							<div class="row akkurate-small">
								<div class="col-md-6 fw-bold akkurate-gray">
									Principal
								</div>
								<div class="col-md-6 report-s-text">
									${this.institution?.currency_code}}
									${this.displayNumber(this.loan?.principal_balance)
				}
								</div>
								<div class="col-md-6 fw-bold akkurate-gray">
									Rate
								</div>
								<div class="col-md-6 report-s-text">
									${this.loan?.interest_rate} % 
									${this.loan?.interest_rate_frequency}
								</div>

								<div class="col-md-6 fw-bold akkurate-gray">
									Tenure
								</div>
								<div class="col-md-6 report-s-text">
									${this.loan?.tenor}
									${this.loan?.tenor_interval}
								</div>
								<div class="col-md-6 fw-bold akkurate-gray">
									Interest Method
								</div>
								<div class="col-md-6 report-s-text">
									${this.loan?.interest_method}
								</div>
								<div class="col-md-6 fw-bold akkurate-gray">
									Interest Frequency
								</div>
								<div class="col-md-6 report-s-text">
									${this.loan.interest_rate_frequency}
								</div>
								<div class="col-md-6 fw-bold akkurate-gray">
									Interest Cycle
								</div>
								<div class="col-md-6 report-s-text">
									${this.loan.loan_product.interest_rate_frequency}
								</div>
								<div class="col-md-6 fw-bold akkurate-gray">
									Repayment Cycle
								</div>
								<div class="col-md-6 report-s-text">
									${this.loan.repayment_cycle}
								</div>
								<div class="col-md-6 fw-bold akkurate-gray">
									Number of Payments
								</div>
								<div class="col-md-6 report-s-text">
									${this.loan.number_of_payment}
								</div>
							</div>
						</div>
					</div>
				`

			content.appendChild(head)
			content.appendChild(scheduleContent)

			// console.log("here");
			const pdfOptions = {
				margin: [0.1, 0, 0.55, 0], // top, right, bottom, left margins,
				filename: "schedule.pdf",
				image: { type: "jpeg", quality: 0.98 },
				html2canvas: { scale: 2 },
				jsPDF: {
					unit: "in",
					format: "a4",
					orientation: "portrait",
				},
			};
			html2pdf()
				.from(content)
				.set(pdfOptions)
				.toPdf()
				.get("pdf")
				.then((pdf) => {
					var totalPages = pdf.internal.getNumberOfPages();
					var insit_name = this.institution.name;
					var insit_tele = this.institution.telephone;
					var insit_email = this.institution.email;
					var insit_motto = this.institution.motto;

					for (var i = 1; i <= totalPages; i++) {
						pdf.setPage(i);
						pdf.setFontSize(8);
						pdf.setTextColor(150);
						pdf.text(
							[
								"For Inquiries, Please Contact " +
								insit_name +
								", Customer Service on " +
								insit_tele +
								"",
								"or email us on " +
								insit_email +
								" " +
								insit_motto +
								"",
								"Page " + i + " of " + totalPages,
							],
							pdf.internal.pageSize.getWidth() / 2,
							pdf.internal.pageSize.getHeight() - 0.4,
							{ align: "center" }
						);
					}

					// Get the blob of the PDF
					return pdf.output("blob");
				})
				.then((pdfBlob) => {
					// Create a URL for the PDF blob
					var pdfUrl = URL.createObjectURL(pdfBlob);

					// Open the URL in a new tab
					const printWindow = window.open(
						pdfUrl,
						"_blank",
						"width=800,height=600"
					);
					printWindow.onload = () => {
						printWindow.print();
						// URL.revokeObjectURL(url);
					};
				})
				.catch((error) => {
					console.error("Error generating PDF:", error);
				});
		},
		async getScheme() {
			this.$Progress.start();
			await ApiService.get("/loans/loanProductSchemes")
				.then((response) => {
					this.$Progress.finish();
					this.scheme_options = response.data.data;
					// console.log(response.data.data);
				})
				.catch((error) => {
					this.$Progress.fail();
					// console.log(error);
				});
		},
		async updateSetOff() {
			const newValue = this.au_form.automatic_set_off; // true or false
			const loanNumber = this.loan.loan_number;
			const action = this.loan.automatic_set_off == 0 ? "ON" : "OFF";

			// Ask for confirmation
			swal.fire({
				title: "Please confirm",
				html: `Are you sure you want to turn <strong>${action}</strong> Automatic Setoff for loan <strong>${loanNumber}</strong>?`,
				icon: "info",
				allowOutsideClick: true,
				allowEscapeKey: true,
				showCancelButton: true,
				confirmButtonText: "Yes",
				cancelButtonText: "No",
				buttonsStyling: false,
				customClass: {
					confirmButton:
						"btn btn-size akkurate-green-btn modal-btn-width text-white me-2",
					cancelButton:
						"btn btn-size akkurate-gray-btn modal-btn-width text-white",
				},
			}).then(async (result) => {
				if (result.isConfirmed) {
					this.$Progress.start();

					const endpoint = newValue
						? `/loans/update/${this.loan.id}/turn-on-setoff`
						: `/loans/update/${this.loan.id}/turn-off-setoff`;

					ApiService.put(endpoint)
						.then((response) => {
							this.$Progress.finish();
							swal.fire({
								text: response.data.message,
								icon: "success",
								confirmButtonText: "Done",
								buttonsStyling: false,
								customClass: {
									confirmButton:
										"btn btn-size akkurate-green-btn modal-btn-width text-white me-2",
								},
							});
							this.getSingleLoan();
						})
						.catch((error) => {
							this.$Progress.fail();
							swal.fire({
								text: error.response.data.message,
								icon: "error",
								confirmButtonText: "Done",
								buttonsStyling: false,
								customClass: {
									confirmButton:
										"btn btn-size akkurate-green-btn modal-btn-width text-white me-2",
								},
							});

							// Revert toggle because the request failed
							this.au_form.automatic_set_off = !newValue;
						});
				} else {
					// User cancelled → reset checkbox to previous state
					this.au_form.automatic_set_off = !newValue;
				}
			});
		}

	},
};
</script>

<style>
.custom-auto-setoff-label{
	height: 0px;
}
</style>